/**
 * Formats mention text by removing user IDs and keeping only names
 * Converts: "Hey @[John Doe](user-id-123), check this out"
 * To: "Hey @John Doe, check this out"
 */
export const formatMentions = (text: string): string => {
  if (!text) return '';

  // Replace @[Name](id) with @Name
  return text.replace(/@\[([^\]]+)\]\([^)]+\)/g, '@$1');
};
